module.exports = __webpack_public_path__ + "static/media/taken-alien.f56ac9e7.svg";